var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08325 12.5C2.08325 6.74701 6.74695 2.08331 12.4999 2.08331C18.2528 2.08331 22.9166 6.74701 22.9166 12.5C22.9166 18.2529 18.2528 22.9166 12.4999 22.9166C6.74695 22.9166 2.08325 18.2529 2.08325 12.5ZM12.4999 9.37498C12.189 9.37498 11.9108 9.50994 11.7184 9.72792C11.3377 10.1592 10.6794 10.2003 10.2481 9.81959C9.81679 9.4389 9.77575 8.78063 10.1564 8.3493C10.7275 7.70227 11.5664 7.29165 12.4999 7.29165C14.2259 7.29165 15.6249 8.69076 15.6249 10.4166C15.6249 11.7783 14.7548 12.9345 13.5416 13.3635V13.5416C13.5416 14.117 13.0752 14.5833 12.4999 14.5833C11.9246 14.5833 11.4583 14.117 11.4583 13.5416V13.0208C11.4583 12.1129 12.1742 11.575 12.7585 11.4262C13.2093 11.3114 13.5416 10.9015 13.5416 10.4166C13.5416 9.84135 13.0752 9.37498 12.4999 9.37498ZM12.4999 15.625C11.9246 15.625 11.4583 16.0913 11.4583 16.6666C11.4583 17.242 11.9246 17.7083 12.4999 17.7083H12.5103C13.0856 17.7083 13.552 17.242 13.552 16.6666C13.552 16.0913 13.0856 15.625 12.5103 15.625H12.4999Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.9f14c0a0ab6309734c627ccddb65c474.svg";
export { ForwardRef as ReactComponent };